import { createFlowCard } from "@deliverr/ui-facility/lib-facility/flow/createFlowCard";
import { ScanFlowCardType } from "crossdock/common/flow/ScanFlowCardType";

export const createDamagedProductCard = createFlowCard(ScanFlowCardType.DAMAGED_PRODUCT);
